import React from 'react'

export const Guide = ({
  width = '82',
  height = '83',
  fill = 'none',
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 82 83"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M61.5 23.6107C61.3333 23.4208 61.1173 23.1714 60.8663 22.8744C60.2618 22.159 59.457 21.1702 58.6532 20.074C57.8481 18.9759 57.0516 17.7802 56.4584 16.6499C55.8564 15.503 55.5 14.4897 55.5 13.7373C55.5 10.503 58.1784 7.8623 61.5 7.8623C64.8216 7.8623 67.5 10.503 67.5 13.7373C67.5 14.4897 67.1436 15.503 66.5416 16.6499C65.9484 17.7802 65.1519 18.9759 64.3468 20.074C63.543 21.1702 62.7382 22.159 62.1337 22.8744C61.8827 23.1714 61.6666 23.4208 61.5 23.6107ZM58.8333 13.7373C58.8333 15.2013 60.0312 16.3623 61.5 16.3623C62.9727 16.3623 64.1667 15.2008 64.1667 13.7373C64.1667 12.2733 62.9688 11.1123 61.5 11.1123C60.0312 11.1123 58.8333 12.2733 58.8333 13.7373Z"
        fill="#1D2943"
        stroke="#2E3860"
      />
      <path
        d="M14.0669 69.1355C14.0669 69.1355 50.8984 69.1355 62.8949 69.1355C74.8914 69.1355 73.8848 46.1099 62.8949 46.1099C51.905 46.1099 60.6032 46.1099 49.7271 46.1099C38.8511 46.1099 38.8511 24.8555 49.7271 24.8555C60.6032 24.8555 59.4542 24.8555 59.4542 24.8555"
        stroke="#AEAFC7"
        stroke-width="1.4"
        strokeDasharray="4 4"
      />
      <path
        d="M14 68.3069C13.7056 67.9703 13.2996 67.4997 12.8177 66.9249C11.7933 65.7028 10.4289 64.0131 9.06609 62.1395C7.70141 60.2633 6.34849 58.2166 5.33963 56.279C4.3188 54.3183 3.7 52.5612 3.7 51.2373C3.7 45.6275 8.30612 41.0623 14 41.0623C19.6939 41.0623 24.3 45.6275 24.3 51.2373C24.3 52.5612 23.6812 54.3183 22.6604 56.279C21.6515 58.2166 20.2986 60.2633 18.9339 62.1395C17.5711 64.0131 16.2067 65.7028 15.1823 66.9249C14.7004 67.4997 14.2944 67.9703 14 68.3069ZM9.63333 51.2373C9.63333 53.6422 11.5871 55.5623 14 55.5623C16.4193 55.5623 18.3667 53.6415 18.3667 51.2373C18.3667 48.8324 16.4129 46.9123 14 46.9123C11.5871 46.9123 9.63333 48.8324 9.63333 51.2373Z"
        fill="#D72B4F"
        stroke="#D72B4F"
        stroke-width="1.4"
      />
    </svg>
  )
}
